import API from "services";
import { useQuery } from "react-query";

export const useGoogleGeoTargets = () =>
  useQuery(["googleGeoTargets"], API.services.adLibrary.getGoogleGeoTargets, {
    staleTime: Infinity,
  });
